import { LoadingOutlined } from "@ant-design/icons";
import { Progress } from "antd";
import { VerticalSpacedDiv } from "components/divs";
import styled from "styled-components";

export type GraphProcessingStep =
  | "aggregating"
  | "boosting"
  | "converting"
  | "loading"
  | "requested";

const STEPS: Record<
  GraphProcessingStep,
  { index: number; label: string; scale?: number }
> = {
  requested: { index: 0, label: "Requesting IAM graph", scale: 0.5 },
  loading: { index: 0.5, label: "Downloading IAM graph", scale: 0.5 },
  converting: { index: 1.0, label: "Converting data", scale: 0.5 },
  // Boost takes ~5x as long as anything else, so have it consume that much more
  // of the progress bar
  boosting: { index: 1.5, label: "Adding search boost", scale: 3 },
  aggregating: { index: 4.5, label: "Aggregating graph data", scale: 0.5 },
};

const MAX_LOADING_INDEX = 5;

// prevent progress from appearing to move backward when step is reset to lower values
const ChunkedProgress = styled(Progress)`
  .ant-progress-bg-outer {
    transition: unset;
  }
`;

export const GraphProcessingStep: React.FC<{
  step: GraphProcessingStep;
  percentage?: number;
}> = ({ step, percentage = 0 }) => {
  const { index, label, scale } = STEPS[step];
  return (
    <VerticalSpacedDiv style={{ width: "400px" }}>
      <ChunkedProgress
        percent={
          100 * ((index + percentage * (scale ?? 1)) / MAX_LOADING_INDEX)
        }
        showInfo={false}
      />
      <div>
        <LoadingOutlined style={{ marginRight: "12px" }} />
        {label}
      </div>
    </VerticalSpacedDiv>
  );
};
